import { Event } from '../Event'
import { Identity } from '../../constants'

export interface ArticleReadNextClickedEventProperties {
  current_article_id: string
  selected_article_id: string
}

export class ArticleReadNextClickedEvent extends Event<ArticleReadNextClickedEventProperties> {
  static displayName = 'Article Read Next Clicked'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
